import React from 'react'
import { initializeApollo } from '@gql/client'
import {
  ListingArchivioDocumentiDocument,
  ListingArchivioDocumentiQuery,
  ListingArchivioDocumentiQueryVariables,
  PaginaDocument,
} from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import CodiceEticoTemplate from '@components/templates/CodiceEticoTemplate/CodiceEticoTemplate'

const Segnalazioni = ({ pagina, documenti, mainContent }) => (
  <CodiceEticoTemplate
    pagina={pagina}
    documenti={documenti}
    mainContent={mainContent}
    etico={false}
  />
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ preview, previewData, locale }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'segnalazioni', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { listingArchivioDocumenti },
    } = await client.query<ListingArchivioDocumentiQuery, ListingArchivioDocumentiQueryVariables>({
      query: ListingArchivioDocumentiDocument,
      variables: {
        slug: 'segnalazioni-ad-organismo-di-vigilanza-di-emak-spa',
        pageKey: pagina.chiave,
      },
      context: {
        headers,
      },
    })

    if (
      !listingArchivioDocumenti ||
      !listingArchivioDocumenti.elementi ||
      !listingArchivioDocumenti.elementi.length
    ) {
      return {
        notFound: true,
      }
    }

    const mainContent = pagina?.pagebuilders?.find((x) => x.key === 'main') ?? null

    return {
      props: { pagina, documenti: listingArchivioDocumenti.elementi, mainContent },
      revalidate: 60 * 20,
    }
  },
  '/'
)

export default Segnalazioni
